import ComsImg from "public/cloudUnifiedCom/coms-main-screen 1.png";

export const COMS_CONSTANTS = {
  heading: ["Work from anywhere.", "Connect everything,", "right from your pocket."],
  description:
    "We bring together secure communication tools so your team stays productive - no matter the device or location, aligned with trends in the global communications market.",
  features: [
    {
      label: "Secure Login Options",
      text: "Log in via Google, Microsoft, or domain credentials. Customizable to your enterprise environment.",
    },
    {
      label: "All-in-One Communication",
      text: "From calls to chats to video — every channel integrated, no switching apps.",
    },
    {
      label: "Sync Across Devices",
      text: "Enjoy full continuity on iOS, Android, Windows, and macOS — always connected.",
    },
  ],
  image: ComsImg,
};
